<section [class]="data.size" test-id="modal">
  <button mat-icon-button (click)="close()">
    <mat-icon svgIcon="close" test-id="close"></mat-icon>
  </button>
  
  <mat-dialog-content class="mat-dialog-content" fxLayout="column">
    <ng-content></ng-content>
  </mat-dialog-content>
</section>